import { useEffect } from 'react';

import { useAnalytics } from '#/shared/hooks/useAnalytics';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

export function usePageStateTracking(): void {
  const pageState = usePageStateStore(state => state.pageState);
  const timesheetId = useTimesheetStore(state => state.timesheet?.timesheetId);
  const { track } = useAnalytics();

  useEffect(() => {
    if (pageState === 'loading-error' || pageState === 'invalid-token') {
      track('Online approval web - View Invalid Timesheet Screen');
    }

    if (pageState === 'loading-success') {
      track('Online approval web - View Active Timesheet Screen', {
        Timesheet_ID: timesheetId || '',
        Origination_Source: 'email',
      });
    }
  }, [pageState, track, timesheetId]);
}
